import { ISelfServeBrandOrder } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeBrandOrder";

import { useSelfServeContextStore } from "./SelfServeContext";

interface IUseSelectedBrandOrder {
  selectedBrandOrder: ISelfServeBrandOrder | undefined;
}

export const useSelectedBrandOrder = (): IUseSelectedBrandOrder => {
  const [{ selectedBrandOrder }] = useSelfServeContextStore([
    "selectedBrandOrder",
  ]);

  return {
    selectedBrandOrder,
  };
};
